import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components/macro';
import BaseOverlay, { BaseOverlayProps } from './BaseOverlay';
import { ReactComponent as Arrow } from '../../assets/images/headArrow.svg';
import { ReactComponent as CopyIcon } from 'assets/images/copyIcon.svg';
import copy from 'copy-to-clipboard';
import {
  alertsActions,
  previewFileActions,
} from '../../store/actions';
import { FormattedMainFile } from 'store/models/MainFiles';

interface OCROverlayProps extends BaseOverlayProps {}

const name = 'OCR';
const propsFromDispatchSelector = (state) =>
  state.showOverlay[name] || {};
const Accordion = ({ header, file, children }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(true);
  const handlePreview = (file: FormattedMainFile) => {
    dispatch(previewFileActions.previewFile(file));
  };
  return (
    <SAccordion>
      <SHeader
        className={isOpen ? 'open' : ''}
        onClick={() => setIsOpen(!isOpen)}
      >
        <STextHeader
          onClick={(e) => {
            e.stopPropagation();
            handlePreview(file);
          }}
        >
          {header}
        </STextHeader>
        <SIcon className={isOpen ? 'open' : ''}>
          <Arrow />
        </SIcon>
      </SHeader>
      {isOpen && <div>{children}</div>}
    </SAccordion>
  );
};
const FileInformation = ({ file }) => {
  const dispatch = useDispatch();
  const { bookingNumbers, containerNumbers, sealNumbers } = file?.ocr;
  const handleCopy = (textCopy) => {
    copy(textCopy);
    const message = 'copied to clipboard';
    dispatch(alertsActions.success(message));
    setTimeout(() => {
      dispatch(alertsActions.clear({ message }));
    }, 5000);
  };
  return (
    <Accordion header={file._filename} file={file}>
      <SContent>
        <div>
          {[
            { header: 'Booking No. :', value: bookingNumbers },
            { header: 'Container Number :', value: containerNumbers },
            { header: 'Seal Number :', value: sealNumbers },
          ].map((e, i) => {
            return (
              <SLine key={i}>
                <SToppic>{e.header}</SToppic>
                <SContentLine
                  className={e?.value?.length ? 'cancopy' : ''}
                  onClick={() =>
                    e?.value?.length &&
                    handleCopy(e.value?.join(', '))
                  }
                >
                  {e?.value?.length
                    ? e.value?.join(', ')
                    : 'No result found'}
                  {e?.value?.length ? (
                    <div>
                      <CopyIcon />
                    </div>
                  ) : (
                    ''
                  )}
                </SContentLine>
              </SLine>
            );
          })}
        </div>
      </SContent>
    </Accordion>
  );
};
const OCROverlay: React.FC<OCROverlayProps> = (props) => {
  const propsFromDispatch = useSelector(propsFromDispatchSelector);
  const { selectedFiles } = propsFromDispatch;
  const { open, handleClose: handleCloseFromProps, title } = props;
  const handleClose = () => {
    handleCloseFromProps();
    // NOTE: add any side effect onClose here
  };
  return (
    <BaseOverlay
      open={open}
      handleClose={handleClose}
      fullWidth={true}
      maxWidth="md"
      title={title}
      height={'100%'}
    >
      {/* OCR info */}
      <SContainer>
        {selectedFiles?.map((file, i) => {
          if (
            file?.ocr?.bookingNumbers?.length ||
            file?.ocr?.containerNumbers?.length ||
            file?.ocr?.sealNumbers?.length
          ) {
            return <FileInformation key={i} file={file} />;
          } else {
            return null;
          }
        })}
      </SContainer>
    </BaseOverlay>
  );
};

export default OCROverlay;
const STextHeader = styled.div`
  :hover {
    text-decoration: underline;
  }
`;
const SContainer = styled.div`
  padding: 10px 20px;
`;
const SAccordion = styled.div`
  margin-top: 20px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px 10px 10px 10px;
  &.open {
    border-radius: 10px 10px 0px 0px;
  }
  & > div {
    border: 1px solid #e2e2e2;
  }
`;
const SIcon = styled.div`
  display: flex;
  align-items: center;
  transform: rotate(-180deg);
  &.open {
    transform: rotate(0deg);
  }
`;
const SHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: bold;
  padding: 10px 20px 10px 10px;
  cursor: pointer;
`;
const SToppic = styled.div`
  font-weight: bold;
  width: 25%;
`;
const SContent = styled.div`
  padding: 20px;
`;
const SLine = styled.div`
  line-height: 40px;
  display: flex;
`;
const SContentLine = styled.div`
  display: flex;
  width: 70%;
  &:hover {
    & > div {
      opacity: 1;
    }
  }
  & > div {
    opacity: 0;
    margin-left: 10px;
  }
  &.cancopy {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;
